/* eslint-disable no-param-reassign */
<template>
  <div class="portlet_content">
    <div class="topWrap">
      <div class="tit">
        <!-- {{ currentMonthEng }} {{ currentMonth }} {{ currentYear }} -->
        {{ currentMonthEng }} {{ currentYear }}
      </div>
      <div class="btnWrap">
        <button
          type="button"
          class="btn_pre"
          @click="onClickPrev(currentMonth)"
        />
        <button
          type="button"
          class="btn_next"
          @click="onClickNext(currentMonth)"
        />
      </div>
      <div class="topWrapR">
        <sui-button
          type="button"
          :class="showType==='card'?'btn_ico_month_on':'btn_ico_month_off'"
          @click="onChangeShowTypeClick('card')"
        />
        <sui-button
          type="button"
          :class="showType==='list'?'btn_ico_day_on':'btn_ico_day_off'"
          @click="onChangeShowTypeClick('list')"
        />
      </div>
    </div>
    <!-- 달력 -->
    <div
      v-if="showType==='card'"
      class="bodyWrap"
    >
      <ul class="calendar_index">
        <li class="holiday">
          {{ $t('MSG_TXT_HLDY_CAL') }}
        </li>
        <li class="public_holiday">
          {{ $t('MSG_TXT_HLDY_PUBLIC_CAL') }}
        </li>
        <li class="event">
          {{ $t('MSG_TXT_EVNT_CAL') }}
        </li>
      </ul>
      <table>
        <thead>
          <tr>
            <th
              v-for="day in days"
              :key="day.id"
              scope="col"
              :class="day.id === $t('MSG_TXT_SUN') ? 'sun': ''"
            >
              {{ day.id }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in currentCalendarMatrix"
            :key="'row_'+index"
          >
            <td
              v-for="(item, index2) in row"
              :key="index2"
              :class="{
                'sun': index2 === 6,
                'selected': item.date === toDay && currentYear === toYear && currentMonth === toMonth
              }"
              :style="item.dayEvent.length > 0 ? 'cursor:pointer' : 'cursor:default'"
              @click="item.dayEvent.length > 0 ? onChangeShowTypeClick('list', item.date) : ''"
            >
              {{ item.date }}
              <ul
                v-if="item.dayEvent.length"
                class="dotWrap"
              >
                <!--<li
                  v-for="(evt, idx) in item.dayEvent"
                  :key="idx"
                  :class="evt.clsName"
                />-->
                <li
                  v-show="onOffDayIcon(item.dayEvent, 'special')"
                  class="special"
                />
                <li
                  v-show="onOffDayIcon(item.dayEvent, 'public')"
                  class="public"
                />
                <li
                  v-show="onOffDayIcon(item.dayEvent, 'event')"
                  class="event"
                />
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 목록 -->
    <div
      v-else-if="showType==='list'"
      class="bodyWrap d"
    >
      <ul
        v-if="listTypeList.length > 0"
        class="day eventday-list"
      >
        <li
          v-for="eventList in listTypeList"
          :key="eventList.date"
          :ref="`homecal-${eventList.date}`"
        >
          <div class="date">
            <span
              :class="toDayStr === eventList.date
                && currentYear === toYear
                && currentMonth === toMonth ? 'today' : 'notoday'"
            />
            {{ eventList.date }}
            <span
              :class="toDayStr === eventList.date ? 'toDayWeek' : 'week'"
            >
              {{ getDayName(currentYear, currentMonth, eventList.date) }}
            </span>
          </div>
          <div>
            <div
              v-for="(item, index) in eventList.dayEvent"
              :key="index"
              :class="{
                'special': item.holidayTypeCode ==='S',
                'public': item.holidayTypeCode ==='H',
                'event': item.holidayTypeCode ==='E'
              }"
            >
              {{ item.holidayName }}
            </div>
          </div>
        </li>
      </ul>
      <div
        v-else
        class="no-event"
      >
        {{ $t("MSG_ALT_NO_HLDY_EVNT") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMY_00029', // eslint-disable-line vue/name-property-casing
  props: {
    pageItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pageName: 'PGE_CMY_00029',
      dateContext: moment(),
      days: [
        { id: this.$t('MSG_TXT_MON_ABB') },
        { id: this.$t('MSG_TXT_TUE_ABB') },
        { id: this.$t('MSG_TXT_WED_ABB') },
        { id: this.$t('MSG_TXT_THU_ABB') },
        { id: this.$t('MSG_TXT_FRI_ABB') },
        { id: this.$t('MSG_TXT_SAT_ABB') },
        { id: this.$t('MSG_TXT_SUN_ABB') },
      ],
      rootYear: 1904,
      rootDayOfWeekIndex: 4, // 2000년 1월 1일은 토요일
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      currentDay: new Date().getDate(),
      currentMonthStartWeekIndex: null,
      currentCalendarMatrix: [],
      endOfDay: null,
      memoDatas: [],
      currentMonthEng: moment().format('MMM'),
      showType: 'card',
      holidayList: [],
      holidayCard: [],
      listTypeList: [],
      toDay: new Date().getDate(),
      toDayStr: new Date().getDate() < 10 ? `0${new Date().getDate()}` : `${new Date().getDate()}`,
      toYear: new Date().getFullYear(),
      toMonth: new Date().getMonth() + 1,
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    this.init();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onOffDayIcon(obj, type) {
      return utils.findIndex(obj, { clsName: type }) > -1;
    },
    getDayName(year, month, day) {
      // const tmpDay = day < 10 ? `0${day}` : `${day}`;
      const tmpMonth = month < 10 ? `0${month}` : `${month}`;
      const dateValue = `${year}${tmpMonth}${day}`;
      const formatDay = moment(dateValue).format('ddd');
      let dsplDay = '';
      switch (formatDay) {
        case 'Mon':
          dsplDay = this.$t('MSG_TXT_MON_ABB');
          break;
        case 'Tue':
          dsplDay = this.$t('MSG_TXT_TUE_ABB');
          break;
        case 'Wed':
          dsplDay = this.$t('MSG_TXT_WED_ABB');
          break;
        case 'Thu':
          dsplDay = this.$t('MSG_TXT_THU_ABB');
          break;
        case 'Fri':
          dsplDay = this.$t('MSG_TXT_FRI_ABB');
          break;
        case 'Sat':
          dsplDay = this.$t('MSG_TXT_SAT_ABB');
          break;
        case 'Sun':
          dsplDay = this.$t('MSG_TXT_SUN_ABB');
          break;
        default:
          break;
      }
      return dsplDay;
    },
    _makeList(selDate) {
      // this.listTypeList = utils.groupBy(this.holidayList, 'holidayDay');
      const tmpObj = utils.groupBy(this.holidayList, 'holidayDay');
      this.listTypeList.splice(0);
      utils.forEach(tmpObj, (value, key) => {
        this.listTypeList.push({ date: key, dayEvent: value });
      });

      // this.listTypeList = _.sortBy(this.listTypeList, ['date']);
      this.listTypeList = utils.orderBy(this.listTypeList, ['date']);

      // selected date move positon
      if (selDate) {
        this.$nextTick(() => {
          // const tmpRef = 'homecal-' + (selDate < 10 ? `0${selDate}` : `${selDate}`);
          const tmpRef = `homecal-${selDate < 10 ? `0${selDate}` : `${selDate}`}`;
          const topPos = this.$refs[tmpRef][0].offsetTop - 62; // 보정치 62
          document.querySelector('.bodyWrap .day.eventday-list').scrollTop = topPos;
        });
      }
    },
    onChangeShowTypeClick(type, selDate) {
      this.showType = type;
      if (this.showType === 'list') this._makeList(selDate);
    },
    init() {
      this.currentMonthStartWeekIndex = this.getStartWeek(this.currentYear, this.currentMonth);
      this.endOfDay = this.getEndOfDay(this.currentYear, this.currentMonth);

      this.getHolidayInfo();
    },
    initCalendar() {
      this.currentCalendarMatrix = [];
      let day = 1;
      for (let i = 0; i < 6; i += 1) {
        const calendarRow = [];
        for (let j = 0; j < 7; j += 1) {
          if (i === 0 && j < this.currentMonthStartWeekIndex) {
            calendarRow.push({ date: '', dayEvent: [] });
          } else if (day <= this.endOfDay) {
            const chkDay = day < 10 ? `0${day}` : `${day}`;
            const eventObj = utils.filter(this.holidayList, { holidayDay: chkDay });

            utils.forEach(eventObj, item => {
              let tmpClass = '';
              switch (item.holidayTypeCode) {
                case 'S': tmpClass = 'special'; break;
                case 'H': tmpClass = 'public'; break;
                case 'E': tmpClass = 'event'; break;
                default: tmpClass = '';
              }
              // eslint-disable-next-line no-param-reassign
              item.clsName = tmpClass;
            });

            calendarRow.push({ date: day, dayEvent: eventObj });
            day += 1;
          } else {
            calendarRow.push({ date: '', dayEvent: [] });
          }
        }
        this.currentCalendarMatrix.push(calendarRow);
      }
    },
    getEndOfDay(year, month) {
      switch (month) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          return 31;
          // break;
        case 4:
        case 6:
        case 9:
        case 11:
          return 30;
          // break;
        case 2:
          // eslint-disable-next-line no-mixed-operators
          if ((year % 4 === 0) && (year % 100 !== 0) || (year % 400 === 0)) {
            return 29;
          }
          return 28;
          // break;
        default:
          // console.log(`unknown month ${month}`);
          return 0;
          // break;
      }
    },
    getStartWeek(targetYear, targetMonth) {
      let year = this.rootYear;
      let month = 1;
      let sumOfDay = this.rootDayOfWeekIndex;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        if (targetYear > year) {
          for (let i = 0; i < 12; i += 1) {
            sumOfDay += this.getEndOfDay(year, month + i);
          }
          year += 1;
        } else if (targetYear === year) {
          if (targetMonth > month) {
            sumOfDay += this.getEndOfDay(year, month);
            month += 1;
          } else if (targetMonth === month) {
            return (sumOfDay) % 7;
          }
        }
      }
    },
    onClickPrev(month) {
      const months = month - 1;
      if (months <= 0) {
        this.currentMonth = 12;
        this.currentYear -= 1;
      } else {
        this.currentMonth -= 1;
      }

      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (months <= 0) {
        const month1 = 11;
        this.currentMonthEng = monthNames[month1];
      } else {
        const month2 = months - 1;
        this.currentMonthEng = monthNames[month2];
      }

      this.init();
    },
    onClickNext(month) {
      const months = month + 1;
      if (months > 12) {
        this.currentMonth = 1;
        this.currentYear += 1;
      } else {
        this.currentMonth += 1;
      }

      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (months > 12) {
        const month1 = 0;
        this.currentMonthEng = monthNames[month1];
      } else {
        const month2 = month;
        this.currentMonthEng = monthNames[month2];
      }

      this.init();
    },
    isToday(year, month, day) {
      const date = new Date();
      return year === date.getFullYear() && month === date.getMonth() + 1 && day === date.getDate();
    },
    getHolidayInfo() {
      let curMonth = this.currentMonth;
      if (curMonth < 10) {
        curMonth = `0${curMonth}`;
      }
      const queryParams = {
        currentDate: `${this.currentYear}${curMonth}`,
      };

      http.request(this.$options.name, 'DTS_CMZ_00138', {
        query: queryParams,
      }).then(res => {
        // console.log(res);
        this.holidayList = res.data;
        this.holidayCard = utils.clone(res.data);
        this.initCalendar();
        if (this.showType === 'list') this._makeList();
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped>
.portlet_content {
  /*height:100%;*/
  /* height:256px; */
  overflow: hidden;
}
.topWrap {display:inline-flex;width:100%;padding:18px 28px 0 28px;line-height:20px;}
.topWrap .tit {font-size:16px; color:#333;width:70px;white-space: nowrap;}
.topWrap .btnWrap {padding-left:5px;line-height:15px;}
.btn_pre {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    background:url('../../../../assets/images/btn_prev_normal.png') no-repeat center center
}
.btn_pre:hover {background:url('../../../../assets/images/btn_prev_hover.png') no-repeat center center}
.btn_next {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    background:url('../../../../assets/images/btn_next_normal.png') no-repeat center center
}
.btn_next:hover {background:url('../../../../assets/images/btn_next_hover.png') no-repeat center center}
.topWrap .topWrapR {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin-left: auto;
}
.topWrapR button {margin-left:-1px}
.topWrapR .btn_ico_day_on {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    border: 1px solid #ccc;
    background:url('../../../../assets/images/ic_calendar_list_selected.png') no-repeat center center
}
.topWrapR .btn_ico_month_on {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    border: 1px solid #ccc;
    background:url('../../../../assets/images/ic_calendar_grid_selected.png') no-repeat center center
}
.topWrapR .btn_ico_day_off {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    background:url('../../../../assets/images/ic_calendar_list_normal.png') no-repeat center center
}
.topWrapR .btn_ico_month_off {
    text-indent: -9999px;
    width: 22px;
    height: 22px;
    background:url('../../../../assets/images/ic_calendar_grid_normal.png') no-repeat center center
}


/***********  calendar  ********************/
.bodyWrap {padding:0 28px}
.bodyWrap.d {padding:0}
.bodyWrap table{
  width:100%;
  border-collapse: collapse;
}
.bodyWrap table,th,tr {
  text-align: center;
  vertical-align:center;
}
.bodyWrap table thead th {font-size:10px; color:#767676}
.bodyWrap table tbody td {font-size:11px; color:#5a5a5a;height:30px; width:28px;}
.bodyWrap table thead th.sun , .bodyWrap table tbody td.sun {color:#ff5230}
.dotWrap { display: flex;justify-content: center;margin-bottom:-4px;}
.dotWrap li { margin:0 1px}
.dotWrap li.special{text-indent: -9999px;width: 4px; height: 4px; background-color: #6952db;}
.dotWrap li.public{text-indent: -9999px;width: 4px; height: 4px; background-color: #0ebb59;}
.dotWrap li.event{text-indent: -9999px;width: 4px; height: 4px; background-color: #73a2ff;}
.bodyWrap a{text-decoration: none;}

.bodyWrap tbody a{}
.bodyWrap tbody a:hover{}

.null{color: gray;}

.selected{cursor:pointer; background-color:#e9ecf7;border:1px solid #7e91d1;}

.selected a{color:#2949b3 !important;font-size:11px;font-weight:bold}

/*******************/

/***********  day  ********************/
/* .bodyWrap {width:310px} */
.bodyWrap .day {height:192px;overflow:hidden;overflow-y:auto; width:100%;margin-top:20px}
/* .bodyWrap .day li {display:inline-flex;width:100%;height:34px;margin-bottom:4px} */
.bodyWrap .day li {
  display: inline-flex;
  width: 100%;
  padding-left:24px
}
.bodyWrap .day .date {
  display:flex;
  position:relative;
  justify-content: center;
  font-size: 16px;
  color: #333;
  align-items: flex-start;
  height: 34px;
  flex-wrap: nowrap;
  margin-right:18px
}
.bodyWrap .day .date span.today:before {
  display: inline-block;
  content: '';
  width: 4px !important;
  height:4px;
  border-radius: 20px;
  background-color: #ff5858;
  position:relative;
  left:-4px;
  top: -10px;
}
.bodyWrap .day .date span.notoday:before {
  display: inline-block;
  content: '';
  width: 4px;
  height:4px;
  border-radius: 20px;
  background-color: #ffffff;
  position:relative;
  left:-5px;
  top: -10px;
}
.bodyWrap .day .date span.week{
  margin-top:20px;
  font-size: 10px;
  color: #767676;
  text-align: center;
  position: absolute;
  left:9px;

}
.bodyWrap .day .date span.toDayWeek{
  margin-top:20px;
  margin-left: 5px;
  font-size: 10px;
  color: #767676;
  text-align: center;
  position: absolute;
  left:5px;

}
.bodyWrap .day .special {
  width:220px;
  display:flex;
  justify-content:flex-start;
  align-items: center;
  padding-left: 20px;
  margin-left:auto;
  font-size:12px;
  color:#333;
  border-left:2px solid #6952db;
  background-color:#E1DCF8;
  height: 34px;
  margin-bottom:4px;
}
.bodyWrap .day .public  {
  width:220px;
  display:flex;
  justify-content:flex-start;
  align-items: center;
  padding-left:20px;
  margin-left:auto;
  font-size:12px;
  color:#333;
  border-left:2px solid #0ebb59;
  background-color:#D2F2E0;
  height: 34px;
  margin-bottom:4px;
}
.bodyWrap .day .event   {
  width:220px;
  display:flex;
  justify-content:flex-start;
  align-items: center;
  padding-left: 20px;
  margin-left:auto;
  font-size:12px;
  color:#333;
  border-left:2px solid #73a2ff;
  background-color:#E3ECFF;
  height:34px;
  margin-bottom:4px;
}

.no-event {
  color: #CCC;
  height: 210px;
  line-height: 210px;
  text-align: center;
  font-size: 12px;
}
/*******************/

.calendar_index{
    display:inline-flex;
    justify-content: flex-end;
    width:100%;
    position:relative;
    font-size:10px;
    color:#767676;
    padding:10px 0 5px 0
  }

.calendar_index li {padding-left:20px}
.calendar_index li.holiday::before {
  content: "";
  position: absolute;
  top:16px;
  margin-left:-7px;
  width: 4px;
  height: 4px;
  background-color: #0ebb59;
}
.calendar_index li.public_holiday::before {
  content: "";
  position: absolute;
  top:16px;
  margin-left:-7px;
  width: 4px;
  height: 4px;
  background-color:#6952db;
}
.calendar_index li.event::before {
  content: "";
  position: absolute;
  top:16px;
  margin-left:-7px;
  width: 4px;
  height: 4px;
  background-color: #73a2ff;
}
</style>
